import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/legalentity-general-types/legalentity/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
